import Link from "next/link"
import { twJoin } from "@library/tailwindMerge"
import Icon from "@components/UI/Icon"
import { headerDesktopLinks } from "@layouts/NavigationV2/navigation/headerDesktopLinks"

export type NavigationItemProps = {
  item: (typeof headerDesktopLinks)[number]
  theme: string
  onClick: () => void
  activeType: string | undefined
}

export const NavigationItem = ({ item, onClick, activeType }: NavigationItemProps) => (
  <li className={twJoin("whitespace-nowrap")}>
    {item.href ? (
      <Link
        href={item.href}
        className={twJoin("group", activeType === item.href ? "navigation-active-item" : "")}
      >
        <span
          className={twJoin(
            "text-16p font-500",
            "group-hover:text-slate-blue-300",
            "[.light_&]:text-neutral2-900",
            "[.dark_&]:text-neutral2-50",
            "[.neutral_&]:text-neutral2-50"
          )}
        >
          {item.title}
        </span>
      </Link>
    ) : (
      <>
        <button
          className={twJoin("flex items-center group", activeType === item.type ? "navigation-active-item" : "")}
          onClick={onClick}
        >
          <span
            className={twJoin(
              "text-16p font-500",
              "group-hover:text-slate-blue-300",
              "[.navigation-active-item_&]:text-slate-blue-300",
              "[.light_&]:text-neutral2-900",
              "[.dark_&]:text-neutral2-50",
              "[.neutral_&]:text-neutral2-50",
            )}
          >
            {item.title}
          </span>
          <Icon
            className={twJoin(
              "transition-transform",
              "[.navigation-active-item_&]:rotate-180",
              "[.dark_.navigation-active-item_&_svg]:fill-slate-blue-300",
              "[&_svg]:group-hover:fill-slate-blue-300",
              "[.light_&_svg]:fill-neutral-700",
              "[.dark_&_svg]:fill-neutral-50",
              "[.neutral_&_svg]:fill-neutral-50",
              "[.neutral_.navigation-active-item_&_svg]:fill-slate-blue-300",
            )}
            name={"arrow3-down"}
            size={16}
            color={"#"}
          />
        </button>
      </>
    )}
  </li>
)
